document.addEventListener('DOMContentLoaded', () => {
  // Find the popup elements once when the page loads.
  const videoLightbox = document.getElementById('videoLightbox');
  if (!videoLightbox) {
    console.error('Video Lightbox HTML not found. Ensure video-lightbox.liquid is rendered in theme.liquid.');
    return;
  }
  const videoPlayer = document.getElementById('videoLightboxPlayer');
  const closeButton = document.getElementById('closeVideoLightbox');

  // --- CONFIGURATION ---
  const videoMap = {
    '#secret-bonus-video': 'https://cdn.shopify.com/videos/c/o/v/2ff35a7c80ba4c26a7e5d426ac2c1792.mp4',

    '#secret-bonus-video2' : 'https://temp.com'
  };
  // --------------------
  
  // --- CORE FUNCTIONS ---
  const openLightbox = (videoUrl) => {
    if (!videoUrl) return;
    videoPlayer.innerHTML = `<video src="${videoUrl}" controls autoplay playsinline muted loop>Your browser does not support the video tag.</video>`;
    videoLightbox.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    videoLightbox.classList.remove('is-visible');
    videoPlayer.innerHTML = '';
    document.body.style.overflow = 'auto';
  };

  // Attach close listeners once
  closeButton.addEventListener('click', closeLightbox);
  videoLightbox.addEventListener('click', (event) => {
    if (event.target === videoLightbox) {
      closeLightbox();
    }
  });
  // --- END CORE FUNCTIONS ---

  // This is the function that finds and activates our link
  const activateVideoLink = (elementNode) => {
    // Check if the element passed is a link itself, or contains our link
    const triggerLink = elementNode.matches('a') ? elementNode : elementNode.querySelector('a[href="#secret-bonus-video"]');
    
    if (triggerLink && videoMap[triggerLink.getAttribute('href')]) {
      // Check if we've already activated this link to prevent duplicate listeners
      if (triggerLink.dataset.videoActive === 'true') return;

      triggerLink.dataset.videoActive = 'true'; // Mark as activated
      triggerLink.addEventListener('click', (event) => {
        event.preventDefault();
        const videoUrl = videoMap[triggerLink.getAttribute('href')];
        openLightbox(videoUrl);
      });
    }
  };
  
  // --- ADVANCED: OBSERVER FOR DYNAMIC CONTENT ---
  // This watches for when apps add content to the page
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          // A node can be an element, text, etc. We only care about elements.
          if (node.nodeType === 1) { 
            activateVideoLink(node);
          }
        });
      }
    }
  });

  // Start observing the entire body of the page for additions and changes.
  observer.observe(document.body, { childList: true, subtree: true });

  // Finally, run the activation once on page load just in case the link
  // was there from the start and not added by an app.
  activateVideoLink(document.body);
});